import { PanelDesignTokens } from '@primeng/themes/types/panel';

export default {
    root: {
        background: '{content.background}',
        borderColor: 'transperant', //changed by mazars
        color: '{content.color}',
        borderRadius: '{content.border.radius}'
    },
    header: {
        borderWidth: '0 0 0 0', //changed by mazars
        borderColor: '{content.border.color}',
        padding: '1.125rem',
        borderRadius: '5px 5px 0 0'
    },
    toggleableHeader: {
        padding: '0.25rem 1.125rem'
    },
    title: {
        fontWeight: '700'
    },
    content: {
        padding: '1.125rem'
    },
    footer: {
        padding: '1.125rem'
    },
    colorScheme: {
        light: {
            header: {
                background: 'transperant', //changed by mazars
                color: '{text.color}'
            }
        },
        dark: {
            header: {
                background: '{surface.800}',
                color: '{text.color}'
            }
        }
    },
    css: ({ dt }) => `
    .p-panel-header  button{
        margin-left: 0.5rem;
        border-radius: 0 !important;
    }
    `,
} as PanelDesignTokens;
